/* global angular, moment */
(function () {
  'use strict';

  angular
    .module('vcfinance.rksv')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcfinancerksv', {
        url: '/financerksv',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;rksv-zero &gt;</tt></h3><div ui-view="rksvzeroview"></div>
              <h3 class="alert alert-info"><tt>&lt;rksv-init&gt;</tt></h3><div ui-view="rksvinitview"></div>
              
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.vcfinancerksv entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcfinancerksv.allcomponents', {
        url: '/allcomponents',
        resolve: {
          eip: function () {
            return true;
          },
          eipf: function () {
            return false;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'rksvzeroview@playground.vcfinancerksv': {
            component: 'rksvZero',
            bindings: {
            }
          },
          'rksvinitview@playground.vcfinancerksv': {
            component: 'rksvInit',
            bindings: {

            }
          }
        },
        onEnter: function () {
          console.log('playground.vcfinancerksv.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






